export { IxTooltip } from './IxTooltip.js';
